import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SessionsView } from '../../components'
import { ROUTE_SESSIONS } from '../../utils/routingConstants'
import { Row, Grid, Col } from 'react-bootstrap'
import { GA_PAGES } from '../../api/gaHelper'
import { page } from '../../hocs/page'

class PageSessions extends Component {
  render () {
    const { userSession } = this.props
    return (
      <Row>
        <Col md={1} />
        <Col md={10}>
          <Grid fluid>
            <SessionsView title='Sessions' validRelationships={userSession.isAnonymous ? ['public'] : ['mine', 'shared', 'public']} />
          </Grid>
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return { userSession: state.session }
}

export default page(connect(mapStateToProps)(PageSessions), { pageView: GA_PAGES.SESSIONS, uiNavigationRoute: ROUTE_SESSIONS })
